import { IntegrationAbility } from "@/apollo/types";

type AbilityFilterOption = { value: IntegrationAbility; label: string };

export const abilityFilters: AbilityFilterOption[] = [
  { value: IntegrationAbility.EltSource, label: "Data source" },
  { value: IntegrationAbility.ActivateDestination, label: "Reverse ETL" },
];
